import SportCourtShell from "../../shared/SportCourtShell";
import {
  LandscapeTableTennisSvg,
  PortraitTableTennisSvg,
} from "../assets/TableTennisCourtSvgs";
import { SPORT_IDS } from "../../../domain/sport/sportTypes";

export default function TableTennisCourt(props) {
  return (
    <SportCourtShell
      {...props}
      sportId={SPORT_IDS.TABLE_TENNIS}
      courtPresentationId="table_tennis.court.v1"
      PortraitSvg={PortraitTableTennisSvg}
      LandscapeSvg={LandscapeTableTennisSvg}
      /** ITTF: players stay on their end; only serve hand / server changes */
      playerStance="fixedEnds"
    />
  );
}
